// Mock Supabase client - all data flows through FastAPI backend
// This stub prevents import errors from Lovable pages that reference Supabase

const mockQueryBuilder = {
  select: () => mockQueryBuilder,
  insert: () => mockQueryBuilder,
  update: () => mockQueryBuilder,
  delete: () => mockQueryBuilder,
  upsert: () => mockQueryBuilder,
  eq: () => mockQueryBuilder,
  neq: () => mockQueryBuilder,
  gt: () => mockQueryBuilder,
  gte: () => mockQueryBuilder,
  lt: () => mockQueryBuilder,
  lte: () => mockQueryBuilder,
  like: () => mockQueryBuilder,
  ilike: () => mockQueryBuilder,
  in: () => mockQueryBuilder,
  order: () => mockQueryBuilder,
  limit: () => mockQueryBuilder,
  single: () => Promise.resolve({ data: null, error: null }),
  then: (resolve: any) => resolve({ data: [], error: null }),
  maybeSingle: () => Promise.resolve({ data: null, error: null }),
};

const mockAuth = {
  getSession: () => Promise.resolve({ data: { session: null }, error: null }),
  getUser: () => Promise.resolve({ data: { user: null }, error: null }),
  signInWithPassword: () => Promise.resolve({ data: {}, error: { message: "Use FastAPI auth" } }),
  signUp: () => Promise.resolve({ data: {}, error: { message: "Use FastAPI auth" } }),
  signOut: () => Promise.resolve({ error: null }),
  resetPasswordForEmail: () => Promise.resolve({ error: null }),
  onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
};

const mockFunctions = {
  invoke: async () => ({ data: null, error: null }),
};

export const supabase = {
  from: () => mockQueryBuilder,
  auth: mockAuth,
  functions: mockFunctions,
  channel: () => ({
    on: () => ({ subscribe: () => ({ unsubscribe: () => {} }) }),
  }),
  removeChannel: () => {},
} as any;
